/**
 * process.browser is deprecated, and we still need to check in some cases if the current code is running on the server
 *
 * @link https://github.com/vercel/next.js/issues/5354#issuecomment-520305040
 */
export const isBrowser = () => typeof window !== 'undefined'
